import { render, staticRenderFns } from "./PrePayment.vue?vue&type=template&id=147e8586&"
import script from "./PrePayment.vue?vue&type=script&lang=js&"
export * from "./PrePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports